<template>
  <div id="ceo">
    <ValidationObserver ref="form">
      <div class="row mb-3">
        <div class="col-md-5">
          <validation-provider v-slot="{ errors }" rules="required">
            <vue-select
              :options="unidadesDeSaude"
              label="no_us"
              placeholder="Unidades de saúde"
              v-model="form.co_ubs"
              :loading="loadingUnidadesDeSaude"
              :disabled="loadingUnidadesDeSaude"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_us }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <vue-select
              :options="monthOptions"
              label="label"
              placeholder="Mês"
              v-model="form.mes"
              :clearable="false"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-2">
          <validation-provider
            v-slot="{ errors }"
            rules="required|onlyNumbers|ano"
          >
            <input
              type="text"
              class="form-control"
              placeholder="Ano"
              v-model="form.ano"
              v-inputmask="maskNumbers"
              maxlength="4"
            />
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-2">
          <button class="btn" @click="buscar()">Buscar</button>
        </div>
      </div>
    </ValidationObserver>
    <div class="col-md-12 p-0">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs"
        v-model="tabsActive"
      >
        <b-tab title="Produção" active @click="buscarDadosDaTabela('producao')">
          <template v-slot:title>
            <i class="icofont-list"></i> Produção
          </template>
        </b-tab>
        <b-tab title="Meta" @click="buscarDadosDaTabela('meta')">
          <template v-slot:title> <i class="icofont-list"></i> Meta </template>
        </b-tab>
        <b-tab title="Meta" @click="buscarDadosDaTabela('professional')">
          <template v-slot:title>
            <i class="icofont-list"></i> Por profissional
          </template>
        </b-tab>
      </b-tabs>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="info-table">
          <div v-if="tabsActive === 1" class="info-table-item">
            <Subtitle
              @exibirVermelhos="handleExibirVermelhos"
              @exibirVerdes="handleExibirVerdes"
            ></Subtitle>
          </div>
          <div v-if="tabsActive === 1" class="info-table-item">
            <vue-select
              :options="typeCeoOptions"
              label="label"
              placeholder="Tipo CEO"
              v-model="form.typeCeo"
              :clearable="false"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
          <div class="info-table-item">
            <download-files
              :callback-pdf="generatePdf"
              :data="displayedCadastros"
              :fields="_fields"
              :xlsEnabled="true"
              name="CEO"
            >
            </download-files>
          </div>
        </div>
        <tabela-cadastros
          ref="table"
          :cadastros="displayedCadastros"
          :loading="loading"
          :headers="tableSelected"
          @filterSearch="filterSearch($event)"
        ></tabela-cadastros>
      </div>
    </div>
  </div>
</template>

<script>
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import utils from '@/mixins/utils.js'
import TabelaCadastros from './TabelaCadastros.vue'
import Selects from '@/components/utils/Selects.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import Subtitle from './Subtitle'
import {
  dataFieldsMeta,
  dataFieldsProduction,
  dataFieldsProfessional,
} from './utils.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import Masks from '@/mixins/masks'

export default {
  name: 'Ceo',
  components: {
    TabelaCadastros,
    Selects,
    DownloadFiles,
    ValidationObserver,
    ValidationProvider,
    Subtitle,
  },
  mixins: [utils],
  computed: {
    _fields() {
      if (this.tabsActive === 0) {
        return dataFieldsProduction
      }
      if (this.tabsActive === 1) {
        return dataFieldsMeta
      }
      if (this.tabsActive === 2) {
        return dataFieldsProfessional
      }
      return
    },
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      if (this.cadastrosOriginais === null) {
        return []
      }
      let cadastroFiltrados
      if (this.tabsActive === 0) {
        this.cadastros = this.cadastrosOriginais.producao
        return this.cadastros
      }
      if (this.tabsActive === 1) {
        this.cadastros = this.cadastrosOriginais.meta
        this.getCeo()
        cadastroFiltrados = Filter.filtro(
          this.cadastros,
          this.exibirCadastrosVermelhos,
          this.exibirCadastrosVerdes
        )
      }
      if (this.tabsActive === 2) {
        this.cadastros = this.cadastrosOriginais.professional
        return this.cadastros
      }
      if (cadastroFiltrados === undefined) {
        cadastroFiltrados = []
      }
      return cadastroFiltrados
    },
    maskNumbers() {
      return Masks['number']
    },
  },
  data() {
    return {
      dataFieldsProduction: {
        ...dataFieldsProduction,
      },
      dataFieldsMeta: {
        ...dataFieldsMeta,
      },
      dataFieldsProfessional: {
        ...dataFieldsProfessional,
      },
      tabsActive: 0,
      equipe: '',
      cadastros: [],
      cadastrosProducao: [],
      cadastrosMeta: [],
      cadastrosProfessional: [],
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      loading: false,
      equipName: '',
      monthOptions: [
        { label: 'Janeiro', value: '01' },
        { label: 'Fevereiro', value: '02' },
        { label: 'Março', value: '03' },
        { label: 'Abril', value: '04' },
        { label: 'Maio', value: '05' },
        { label: 'Junho', value: '06' },
        { label: 'Julho', value: '07' },
        { label: 'Agosto', value: '08' },
        { label: 'Setembro', value: '09' },
        { label: 'Outubro', value: '10' },
        { label: 'Novembro', value: '11' },
        { label: 'Dezembro', value: '12' },
      ],
      typeCeoOptions: [
        { label: 'Tipo I', value: 'ceo_i' },
        { label: 'Tipo II', value: 'ceo_ii' },
        { label: 'Tipo III', value: 'ceo_iii' },
      ],
      month: '',
      disabledMonth: true,
      cadastrosOriginais: null,
      filterSearchTable: false,
      form: {
        co_ubs: '',
        mes: '',
        ano: '',
        typeCeo: { label: 'Tipo I', value: 'ceo_i' },
      },
      typeTable: 'producao',
      tableSelected: [],
      headerProduction: [
        {
          text: 'SEQUÊNCIA',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'sequencia',
        },
        {
          text: 'PROCEDIMENTO',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'procedimento',
        },
        {
          text: 'CBO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cbo',
        },
        {
          text: 'QUANTIDADE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'quantidade',
        },
      ],
      headerGoal: [
        {
          text: 'CATEGORIA',
          align: 'start',
          filterable: true,
          sortable: true,
          value: 'categoria',
        },
        {
          text: 'META',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'meta',
        },
        {
          text: 'PRODUÇÃO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'quantidade',
        },
      ],
      headerProfessional: [
        {
          text: 'PROFISSIONAL',
          align: 'start',
          filterable: true,
          sortable: true,
          value: 'no_prof',
        },
        {
          text: 'PRODUÇÃO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'quantidade',
        },
        {
          text: 'CATEGORIA',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'categoria',
        },
      ],
      unidadesDeSaude: [],
      loadingUnidadesDeSaude: false,
    }
  },
  mounted() {
    this.tableSelected = this.headerProduction
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Retorna o mês atual
     *
     * @returns {String}
     */
    getCurrentMonth() {
      const date = new Date()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      return month
    },

    /**
     * Atualiza o filtro para exibir registros classificados como vermelhos.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.exibirCadastrosVermelhos = false
      }
    },

    /**
     * Atualiza o filtro para exibir registros classificados como verdes.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.exibirCadastrosVerdes = false
      }
    },

    /**
     * Buscar os dados
     */
    async buscar() {
      this.tabsActive = 0
      this.typeTable = 'producao'
      this.tableSelected = this.headerProduction
      try {
        const isValid = await this.$refs.form.validate()
        if (!isValid) {
          return false
        }

        this.loading = true
        const response = await Functions.getDados(
          this.$store.state.cod_ibge,
          this.form.co_ubs.co_ubs,
          this.form.mes.value,
          this.form.ano
        )
        if (response) {
          this.cadastros = []
          this.cadastrosOriginais = response
          this.cadastrosProducao = response.producao
          this.cadastrosMeta = response.meta
          this.cadastrosProfessional = response.professional
          if (this.tabsActive === 0) {
            this.cadastros = this.cadastrosProducao
          }
          if (this.tabsActive === 1) {
            this.cadastros = this.cadastrosMeta
          }
          if (this.tabsActive === 2) {
            this.cadastros = this.cadastrosProfessional
          }

          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      } finally {
        this.loading = false
      }

      return
    },

    /**
     * Buscar os dados da tabela
     *
     * @param {String} table tipo da tabela
     */
    buscarDadosDaTabela(table) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (this.cadastrosOriginais === null) {
        return
      }
      if (table === 'producao') {
        this.typeTable = 'producao'
        this.cadastros = this.cadastrosProducao
        this.tableSelected = this.headerProduction
        return
      }
      if (table === 'meta') {
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = false
        this.typeTable = 'meta'
        this.cadastros = this.cadastrosMeta
        this.tableSelected = this.headerGoal
        this.getCeo()
        return
      }
      if (table === 'professional') {
        this.typeTable = 'professional'
        this.cadastros = this.cadastrosProfessional
        this.tableSelected = this.headerProfessional
        return
      }
    },

    /**
     * Busca os dados do CEO
     *
     * @returns {Array}
     */
    getCeo() {
      this.cadastros = this.cadastrosOriginais.meta.map((item) => {
        const ceo = this.form.typeCeo.value
        return {
          ...item,
          meta: item[ceo],
        }
      })
    },

    /**
     * Carrega os estabelecimentos de saúde
     */
    async carregarUnidadesDeSaude() {
      try {
        this.loadingUnidadesDeSaude = true
        let response = await this.$api.get(
          `/app/ceo/${this.$store.state.cod_ibge}/unidades-de-saude`
        )
        if (response) {
          this.unidadesDeSaude = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingUnidadesDeSaude = false
      }
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.form.co_ubs.no_us,
        this.form.mes.value,
        this.form.ano,
        this.form.typeCeo.label,
        this.typeTable
      )
    },
  },
  async created() {
    await this.carregarUnidadesDeSaude()
  },
}
</script>

<style lang="scss" scoped src="./styles.scss" />
